import { useState } from 'react';
import { createLogger } from './logger';

export const useLogger = (name: string) => {
  const [logger] = useState(createLogger(name));

  return logger;
};
